import React from 'react';
import { BiSearch } from 'react-icons/bi';
import { useLocation, useNavigate } from 'react-router-dom';

const SearchBarComponent = ({ query, handleInputChangeDebounced }) => {
    const navigate = useNavigate()
    const location = useLocation()
    const handleSearchClick = () => {
        navigate("/s");
    };
    return (
        <div className="search" onClick={() => handleSearchClick()}>
            <input
                type="text"
                placeholder="Search for Artists..."
                value={query}
                onChange={handleInputChangeDebounced}
                autoFocus={location.pathname === "/s"}
            />
            <BiSearch className="option-icon" />
        </div>
    );
};

export default SearchBarComponent;
